module.exports = __webpack_public_path__ + "static/media/banner-mobile.1144fab4.jpg";